import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

export default forwardRef((props, ref) => <Link ref={ref} {...props} />);
